import { BuildingsIconComponent } from 'assets/icons/buildings';
import { ContractBreadcrumbs } from './components/ContractBreadcrumbs';
import { IContract } from 'interfaces/contracts';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Space, Tabs, Tag } from 'antd';
import { TabContractInfo } from './components/TabContractInfo';
import { TabContractStudents } from './components/TabContractStudents';
import { useParams, useSearchParams } from 'react-router-dom';
import { useShow } from '@refinedev/core';

export const ContractShow = () => {
  const params = useParams();
  const { id: contractId, companyId } = params;

  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get('tab');

  const { queryResult } = useShow<IContract>({
    resource: `companies/${companyId}/contracts`,
    id: contractId
  });

  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout
      isLoading={isLoading}
      title="Visualizar contrato"
      breadcrumb={<ContractBreadcrumbs />}
    >
      <PageHeader
        title={`Contrato: ${record?.code}`}
        icon={BuildingsIconComponent}
        meta={
          <Space>
            <Tag>CNPJ: {record?.company?.cnpj}</Tag>
          </Space>
        }
      />

      {record && (
        <Tabs
          defaultActiveKey={currentTab ?? 'info'}
          onChange={e => setSearchParams({ tab: e })}
          className="custom-tabs"
        >
          <Tabs.TabPane tab="Informações Gerais" key="info">
            <TabContractInfo contract={record} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Aluno" key="contracts">
            <TabContractStudents />
          </Tabs.TabPane>
        </Tabs>
      )}
    </ShowLayout>
  );
};
